import React from 'react'
import merge from 'lodash/merge'
import get from 'lodash/get'
import componentList from './component-list'

const getBoxAttribute = (apiBox) => {
  return {
    bgColor: apiBox.backgroundColor,
    bgSrc: apiBox.backgroundImage,
    top: apiBox.top,
    bottom: apiBox.bottom,
    left: apiBox.left,
    right: apiBox.right,
  }
}

const Mapper = ({ component, handlers, inputMap, imageMap, customProps, campaignId, ...rest }) => {
  if (!componentList[component.componentType]) {
    return <div>Unknown Component => {component.componentType}</div>
  }

  const recursive = (components) => {
    return components.map((component) => {
      // use as function instead of component
      // because as function it doesn't break the React children logic
      return Mapper({ component, handlers, inputMap, imageMap, customProps, campaignId, ...rest })
    })
  }

  const defaults = {
    preventChildValidation: true,
    isResponsive: true,
    boxed: true,

    id: component._id,
    key: component._id,

    box: getBoxAttribute(get(component.content, 'box', {})),
  }

  const mergedDefaults = merge(defaults, rest)
  const compProps = {
    component,
    defaults: mergedDefaults,
    recursive,
    handlers,
    inputMap,
    imageMap,
    customProps,
    campaignId,
  }

  return componentList[component.componentType](compProps)
}

export default Mapper
